var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"color":_vm.statusColor}},on),[_vm._v("mdi-circle")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.statusLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }